import { ISSUE_ATTRIBUTE_NAMES } from '../../constants/issue-attribute-names';
import CommonTextarea from './components/CommonTextarea';

const Question = () => (
  <CommonTextarea fieldName={ISSUE_ATTRIBUTE_NAMES.QUESTION} label="new.question" />
);

export default Question;
